var exports = {
  "l": "xa15a2ab7--6eb24c--show-more-button",
};

module.exports = exports;
